module.exports = __webpack_public_path__ + "img/pubBg.e3b6009.png";